/* Right-aligned below the account icon, which is the positioned parent. */
.desktopPrompt {
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  z-index: var(--layers-popover);
}
